import { render, staticRenderFns } from "./ListSetoran.vue?vue&type=template&id=fcd40f4e&"
import script from "./ListSetoran.vue?vue&type=script&lang=js&"
export * from "./ListSetoran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports